<template>
	<div>
		<div class="px-md-3">
			<div class="row no-gutters">
				<div class="col-md-10 offset-md-1" style="animation-delay:50ms">
					<IntroMySelf class="mt-md-5 mt-2" />
					<!-- <img src="../assets/imgs/langs/nodejs.png" class="nodejs-png" style="width: 43px;" id="mouseMoveAni"
						data-value="5" /> -->
				</div>
			</div>
		</div>
		<!-- <div class="p-md-5 bg-dark"
			style="background-image:url('waves-blue.svg');background-size:cover;border: 1px solid #343a40;">
			<div class="pl-md-4 pr-md-4">
				<MyTools />
			</div>
		</div>
		<div class="bg-dark pb-5 mb-3" style="background-image:url('bg1.svg');background-size:cover;">
			<div class="container">
				<IDEWindow />
			</div>
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src
import IntroMySelf from "./../components/IntroMySelf.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";
// import IDEWindow from "./../components/IDEWindow.vue";
// import MyTools from "./../components/My-Too";

export default {
	name: "Home",
	data() {
		return {
			host: process.env.VUE_APP_HOST,
		};
	},
	created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
    },
	components: {
		IntroMySelf,
		// MyTools,
		// IDEWindow
	}
};
</script>

<style scoped>
.bootstratp-img {
	transform: rotate(20deg);
	width: 60px;
	position: relative;
	left: 14%;
}

.nodejs-png {
	transform: rotate(20deg);
	width: 60px;
	position: relative;
	top: 40px;
}
</style>
